import React, { useContext, useEffect, useState } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import {
  Header,
  Sidebar,
  SideBarContent,
  ManageTradeMenu,
  ManageMenu,
  LoaderWrapper,
} from "../components";
import { appLayoutStore, setSelectedMenu, setUserRole } from "../contexts";
import {
  ApplicationRoute,
  ROUTES,
  MANAGE_TRADE_MENU,
  MANAGE_MASTERS_MENU,
} from "../utils";
import tenantConfig from "../mocks/tenantOne.json";
import authService from "../components/api-authorization/AuthorizeService";

const withAppLayout = (Component) => {
  const ComposedComponent = (props) => {
    const { location } = props;
    const { state, dispatch } = useContext(appLayoutStore);
    const menu = tenantConfig.menuItems;

    const getRole = async () => {
      dispatch(setUserRole(await authService.getRole()));
    };
    // enven to handle location change
    useEffect(() => {
      dispatch(setSelectedMenu(location.pathname.split("/")[1]));
      getRole();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
    const isSearch = ["plans", "companys", "employees"].includes(
      location.pathname.slice(1)
    );
    const isAllowed = isSearch
      ? menu.includes(location.pathname.slice(1, location.pathname.length - 1))
      : true;
    return (
      !isEmpty(get(state, "userRole")) && (
        <Sidebar state={state}>
          <Header seletedRoute={get(state, "selectedMenu")} />
          <Container className="app-layout" fluid>
            <Component {...props} />
          </Container>
        </Sidebar>
      )
    );
  };
  return withRouter(ComposedComponent);
};

export default withAppLayout;
